"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var CartContext_1 = require("./CartContext");
var CheckoutButton_1 = require("./CheckoutButton");
var EmptyCart_1 = require("./EmptyCart");
var ReviewContainer_1 = require("./ReviewContainer");
var SlideCartNav_1 = require("./SlideCartNav");
var cart_1 = require("../../utils/cart");
var all_products_1 = require("../../utils/shopify-graphql/all-products");
var ga_1 = require("../../utils/ga");
var use_nav_slide_1 = require("../../hooks/use-nav-slide");
var CartContainer = function () {
    var _a = (0, hooks_1.useState)(null), cart = _a[0], setCart = _a[1];
    var _b = (0, hooks_1.useState)(null), allProducts = _b[0], setAllProducts = _b[1];
    var _c = (0, hooks_1.useState)(false), freeShipping = _c[0], setFreeShipping = _c[1];
    // remove this state if intro offer test loses
    var _d = (0, hooks_1.useState)(sessionStorage.getItem('intro-offer') === 'true'), introOffer = _d[0], setIntroOffer = _d[1];
    var renderCart = (0, hooks_1.useCallback)(function (providedData) { return __awaiter(void 0, void 0, void 0, function () {
        var cartData, _a, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    _a = providedData;
                    if (_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, cart_1.getCartData)()];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    cartData = _a;
                    if (cartData) {
                        setCart(cartData);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    console.error('Error rendering cart:', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, []);
    var _e = (0, use_nav_slide_1.useNavSlide)(), open = _e.open, handleSlide = _e.handleSlide;
    (0, hooks_1.useEffect)(function () {
        var handleSlideCart = function () { return handleSlide(window.scrollY); };
        var handleFetchAndSlideCart = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, renderCart()];
                    case 1:
                        _a.sent();
                        handleSlide(window.scrollY);
                        return [2 /*return*/];
                }
            });
        }); };
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var allProducts;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, renderCart()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, (0, all_products_1.getAllProductsData)()];
                    case 2:
                        allProducts = _b.sent();
                        setAllProducts(allProducts);
                        // If the previous page is checkout or current page is /cart, open the cart
                        if (((_a = sessionStorage.getItem('cartPrevPage')) === null || _a === void 0 ? void 0 : _a.includes('checkouts')) || isCartPage) {
                            handleSlide(window.scrollY);
                        }
                        // Store the current page for checkout to come back
                        sessionStorage.setItem('cartPrevPage', location.pathname);
                        // Listen for slide cart button click
                        document.addEventListener('slideCart', handleSlideCart);
                        // Listen for product add from shop sections
                        document.addEventListener('fetchAndSlideCart', handleFetchAndSlideCart);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            document.removeEventListener('slideCart', handleSlideCart);
            document.removeEventListener('fetchAndSlideCart', handleFetchAndSlideCart);
        };
    }, []);
    if (!cart || !allProducts) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    var hasSubscription = (0, cart_1.hasSubscriptionItem)(cart);
    var upsellModuleVisible = (0, cart_1.showUpsellItem)(cart);
    var discountThreshold = (cart === null || cart === void 0 ? void 0 : cart.total_price) > 1500;
    var isCartPage = window.location.href.includes('/cart');
    // Maximum number of items allowed in a single cart
    var MAX_CART_ITEMS = 15;
    // Maximum subtotal price allowed ($500.00) in cents
    var MAX_CART_SUBTOTAL = 50000;
    var underLimit = cart.item_count <= MAX_CART_ITEMS && cart.items_subtotal_price <= MAX_CART_SUBTOTAL;
    var cartContextValue = (0, hooks_1.useMemo)(function () { return ({
        allProducts: allProducts,
        cart: cart,
        discountThreshold: discountThreshold,
        freeShipping: freeShipping,
        handleSlide: handleSlide,
        hasSubscription: hasSubscription,
        introOffer: introOffer,
        isCartPage: isCartPage,
        open: open,
        renderCart: renderCart,
        setIntroOffer: setIntroOffer,
        upsellModuleVisible: upsellModuleVisible,
        underLimit: underLimit,
    }); }, [
        allProducts,
        cart,
        discountThreshold,
        freeShipping,
        handleSlide,
        hasSubscription,
        introOffer,
        isCartPage,
        open,
        renderCart,
        setIntroOffer,
        upsellModuleVisible,
        underLimit,
    ]);
    (0, hooks_1.useEffect)(function () {
        //run this at the cart component level to update context if $25 threshold isn't met
        if (!discountThreshold) {
            setIntroOffer(false);
        }
        // Update the cart item amount in the cart icon
        var cartAmount = cart.items.reduce(function (accum, curr) { return accum + curr.quantity; }, 0);
        var headerQuantity = document.querySelector('.header__quantity');
        if (headerQuantity) {
            headerQuantity.innerHTML = cartAmount.toString();
        }
        if (hasSubscription || cart.total_price > 7000) {
            setFreeShipping(true);
        }
        else {
            setFreeShipping(false);
        }
    }, [cart]);
    // Send GA event every time cart is displayed
    (0, hooks_1.useEffect)(function () {
        if (open) {
            (0, ga_1.sendEventViewCart)(cart);
        }
    }, [open]);
    return ((0, preact_1.h)("div", { class: "cart" },
        (0, preact_1.h)("div", { class: "cart__overlay ".concat(open ? 'cart__overlay--open' : ''), onClick: function () { return handleSlide(); } }),
        (0, preact_1.h)("div", { class: "cart__main ".concat(open ? 'cart__main--open' : '') },
            (0, preact_1.h)(CartContext_1.default.Provider, { value: cartContextValue },
                (0, preact_1.h)(SlideCartNav_1.default, null),
                cart.items.length ? ((0, preact_1.h)(preact_1.Fragment, null,
                    (0, preact_1.h)(ReviewContainer_1.default, null),
                    underLimit && (0, preact_1.h)(CheckoutButton_1.default, { sticky: true }))) : ((0, preact_1.h)(EmptyCart_1.default, null))))));
};
exports.default = CartContainer;
